import { render, staticRenderFns } from "./Staff08.vue?vue&type=template&id=d11c0a3c&"
import script from "./Staff08.vue?vue&type=script&lang=js&"
export * from "./Staff08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports